var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout',{attrs:{"name":"Clean"}},[_c('div',{staticClass:"link-expired__wrapper"},[_c('VSystemMessage',{attrs:{"primaryText":_vm.sysMessageTitle,"secondaryText":_vm.sysMessageSecondaryText,"actions":_vm.getActions}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }